<template>
  <div class="view-tools-coproducer">
    <h5 class="text-semibold mb-5">Coproduções</h5>
    <div>
      <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
        <div class="row">
          <div class="col-lg-4">
            <snow-select
              id="product-select"
              v-model="product_id"
              label="Selecionar produto..."
              :options="products.map(({ id, name }) => ({ id, name }))"
            />
          </div>
        </div>
      </action-dispatcher>
      <div v-if="product_id" class="pt-5">
        <div class="view-product-coproducers">
          <snow-data-table-header
            v-if="coproducers.length"
            @add="addCoproducer"
            addText="Cadastrar coprodutor"
            :datePicker="false"
            :filters="false"
            :search="false"
          />

          <snow-data-table
            :loading="loading"
            :columns="columns"
            :data="coproducers"
          >
            <template #no-content-actions>
              <snow-button @click="addCoproducer" icon="ph ph-plus">
                Cadastrar um coprodutor
              </snow-button>
            </template>
          </snow-data-table>

          <snow-paginator
            v-if="!loading"
            v-model="page"
            :pagination="pagination"
            @change-page="dispatch"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { formatDate, formatPercentage } from "@/functions/formatting";
import CoProducersMixin from "@/mixins/coproducers.js";
import EditProductMixin from "@/mixins/editProduct.js";
import { mapState } from "vuex";

export default {
  mixins: [CoProducersMixin, EditProductMixin],
  data() {
    return {
      product_id: null,
      page: 1,
      modal: false,
      loading: false,
      columns: [
        {
          name: "E-mail",
          field: "co_producer",
          transform: v => v.email
        },
        {
          name: "Comissão",
          field: "tax",
          transform: formatPercentage
        },
        {
          name: "Validade do contrato",
          field: "contract_time",
          transform: formatDate
        },
        {
          name: "Status",
          field: "status",
          transform: this.formatStatus,
          class: this.formatStatusBadge
        },
        {
          name: "",
          type: "menu",
          disabled: ({ status }) => status !== "active",
          options: v => [
            {
              label: "Desativar",
              variant: "danger",
              class: "text-danger",
              click: this.deactivateCoproducer,
              dialog: {
                text: `Deseja mesmo desativar a coprodução com ${v.co_producer.email}?`,
                icon: "ph ph-prohibit",
                action: this.deactivateCoproducer,
                secondaryButtonText: "Não, cancelar",
                ButtonText: "Sim, desativar"
              }
            }
          ]
        }
      ]
    };
  },
  watch: {
    product_id(product_id) {
      if (product_id) {
        this.dispatch(product_id);
        this.$store.commit(
          "product/setProduct",
          this.products.find(p => p.id === product_id)
        );
      }
    }
  },

  methods: {
    formatStatus(status) {
      const statusMap = {
        active: "Ativo",
        cancelled: "Inativo",
        rejected: "Rejeitado",
        waiting_validation: "Aguardando Aprovação",
        pendent: "Pendente"
      };

      return statusMap[status];
    },
    formatStatusBadge(status) {
      const statusMap = {
        active: "active-badge",
        cancelled: "inactive-badge",
        rejected: "inactive-badge",
        waiting_validation: "draft-badge",
        pendent: "draft-badge"
      };

      return statusMap[status];
    },
    addCoproducer() {
      this.$router.push({
        name: "product-new-coproducer",
        params: { id: this.product_id }
      });
    },
    deactivateCoproducer(coproducer) {
      this.$store
        .dispatch("user/putCoProducerProduct", {
          id: coproducer.id,
          status: "cancelled"
        })
        .then(() => {
          this.$message.success("Coprodução desativada");
          this.refresh();
        })
        .catch(() => this.$message.error("Erro ao desativar coprodução"));
    }
  },
  mounted() {
    this.$store
      .dispatch("product/get", { limit: 500 })
      .then()
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    ...mapState("product", ["products", "product"]),
    breadcrumbs() {
      return [
        {
          link: "tools",
          title: "Ferramentas"
        },
        {
          title: "Coproduções"
        }
      ];
    }
  }
};
</script>
